import {HTMLAttributes, useEffect} from 'react';
import {twMerge} from '../../../../common/twMerge';
import {ContentHomeTabWrapper} from '../../../../design-system/organisms/ContentHomeTabWrapper/ContentHomeTabWrapper';
import {ApiErrorBoundary} from '../../../../errors/ApiErrorBoundary.class';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {ContentHomeNoticeMobileFetcherHeadless} from '../headless/ContentHomeNoticeMobileFetcherHeadless';
import {useContentHomeLastNotice} from '../hook/useContentHomeLastNotice';
import {ContentNoticeTabMobileListContainer} from './ContentNoticeTabMobileListContainer';

export interface ContentNoticeTabMobileContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  seriesId: number;
}

export function ContentNoticeTabMobileContainer({
  seriesId,
  className,
  ...props
}: ContentNoticeTabMobileContainerProps) {
  const overview = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG)
    .data?.contentHomeOverview;

  const {visit} = useContentHomeLastNotice(seriesId);
  useEffect(() => {
    visit();
  }, [visit]);

  return (
    <ContentHomeTabWrapper
      isMobile={true}
      displayAd={overview?.displayAd}
      saleState={overview?.content?.saleState}
      className={twMerge(className, 'flex flex-col space-y-8pxr')}
      {...props}
    >
      <ApiErrorBoundary>
        <ContentHomeNoticeMobileFetcherHeadless seriesId={seriesId}>
          <ContentNoticeTabMobileListContainer seriesId={seriesId} />
        </ContentHomeNoticeMobileFetcherHeadless>
      </ApiErrorBoundary>
    </ContentHomeTabWrapper>
  );
}
